export const projects = [
  {
    name: "IHSG Spectrum Visualizer",
    date: "2026",
    slug: "ihsg-spectrum-visualizer",
    tagline: "Google-Finance-style IDX Composite (IHSG) whose price chart renders as a audio spectrum.",
    highlight: true,
    writeup: "/posts/ihsg-spectrum-visualizer",
    url: "https://ihsg.membasuh.com",
  },
  {
    name: "Save ChatGPT as PDF",
    date: "2026",
    slug: "save-chatgpt-as-pdf",
    tagline: "Download the whole ChatGPT conversation as a clean, formatted PDF in one click.",
    highlight: true,
    writeup: "/posts/save-chatgpt-conversations-as-pdf",
    url: "https://save-chatgpt-as-pdf.membasuh.com",
  },
  {
    name: "Laradock",
    date: "2025",
    slug: "laradock",
    tagline: "🐳 A customizable Laravel development using Docker Compose.",
    highlight: true,
    writeup: "/posts/flexible-docker-based-laravel-development",
  },
  {
    name: "Go-QRIS",
    date: "2024",
    slug: "go-qris",
    tagline: "Go-based tool that converts QRIS code into dynamic ones.",
    highlight: true,
    writeup: "/posts/revolutionizing-qris-transactions",
    url: "https://api.qris.membasuh.com",
    docs: "https://documenter.getpostman.com/view/6937269/2sAYJ1jMc7",
  },
  {
    name: "Fresh Proxy List",
    date: "2024",
    slug: "fresh-proxy-list",
    tagline:
      "An automatically updated list of free HTTP, HTTPS, SOCKS4, and SOCKS5 proxies.",
    highlight: true,
  },
  {
    name: "Auth with Clean Architecture",
    date: "2024",
    slug: "auth-with-clean-architecture",
    tagline:
      "An authentication service built with Go that features clean architecture principles, multi-layered design, and support for deployment.",
    highlight: false,
  },
  {
    name: "Shopee Express Waybill",
    date: "2024",
    slug: "shopee-express-waybill",
    tagline:
      "A lightweight PHP package for tracking Shopee Express shipments with API integration.",
    highlight: false,
    url: "https://shopee-express-waybill.membasuh.com",
    docs: "https://documenter.getpostman.com/view/6937269/2sA3s4nAx2",
  },
  {
    name: "Command Center",
    date: "2024",
    slug: "command-center",
    tagline:
      "The support management system designed to empower political candidates during their campaigns.",
    highlight: false,
    writeup: "/posts/legislative-candidate-support-management-system",
    docs: "https://youtu.be/6NY1PW8iT1o",
  },
  {
    name: "Ittihad Mudarrisi Al-Lughah Al-Arabiyyah",
    date: "2023",
    slug: "imla",
    tagline: "Digitization of membership data to encourage collaboration.",
    highlight: false,
    writeup: "/posts/ittihad-mudarrisi-al-lughah-al-arabiyyah",
  },
  {
    name: "NU Bantul, D.I Yogyakarta",
    date: "2023",
    slug: "nu-bantul",
    tagline:
      "Innovative digital solutions that drive transparency, communication and organizational efficiency.",
    highlight: false,
    writeup: "/posts/nahdlatul-ulama-bantul-management-system",
    url: "https://nubantul.or.id",
  },
  {
    name: "Poultry Manufacturing",
    date: "2022",
    slug: "poultry-manufacture",
    tagline:
      "Streamlined transactions, and transformed workflows — revolutionized efficiency.",
    highlight: false,
    writeup: "/posts/poultry-manufacturing-management-system",
    docs: "https://youtu.be/wFfQVUD-a_A",
  },
  {
    name: "Online Brochure",
    date: "2021",
    slug: "online-brochure",
    tagline:
      "A dynamic online brochure with information about the course and enrollment schedule.",
    highlight: false,
    writeup: "/posts/online-brochure-of-bec",
    url: "https://becpare.id",
  },
  {
    name: "Ministry of Religious Affairs",
    date: "2020",
    slug: "ministry-of-religious-affairs-kebumen",
    tagline:
      "HRMS app to simplify attendance tracking, payroll management and correspondence handling.",
    highlight: false,
    writeup: "/posts/ministry-of-religious-affairs-in-kebumen",
  },
  {
    name: "NU D.I Yogyakarta",
    date: "2020",
    slug: "nu-diy",
    tagline:
      "An integrated system to comprehensively record members and assets.",
    highlight: false,
    writeup: "/posts/nu-di-yogyakarta-management-system",
  },
  {
    name: "Zakirfasir Kaligrafi",
    date: "2020",
    slug: "zakirfasir-kaligrafi",
    tagline:
      "User-friendly website makes it easy for browsing the products and make a purchase.",
    highlight: false,
    writeup: "/posts/zakirfasir-kaligrafi-store",
    url: "https://zakirfasirkaligrafi.com",
  },
  {
    name: "PSKH of UIN Sunan Kalijaga",
    date: "2019",
    slug: "pskh-uin-sunan-kalijaga",
    tagline:
      "Empowering organization through efficient data management and financial transparency.",
    highlight: false,
    writeup: "/posts/pskh-uin-sunan-kalijaga-management-system",
    url: "https://pskhuinsuka.com",
  },
  {
    name: "Smart Tap",
    date: "2018",
    slug: "smart-tap",
    tagline:
      "IoT-based solution for smart water management, integrating sensors and real-time data analytics.",
    highlight: false,
    writeup: "/posts/smart-tap-for-religious-place",
    docs: "https://youtu.be/FDOZL5Con_k",
  },
];
